import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Typography, Drawer, Stack } from "@mui/material";
import ProfileUpdateForm from "./ProfileUpdateForm";
import profileimg from "../../assets/images/auth/profileimg.svg";
import profileBanner from "../../assets/images/Network.svg";
import companyLogo from "../../assets/images/auth/companyLogo.svg";
import CloseIcon from "@mui/icons-material/Close";
import CountryDrawer from "../post/Drawer/CountryDrawer";
import { getCountryList } from "../../appStore/actions/masterData/masterDataAction";
import {
  editSubscriberProfile,
  updateFirmPic,
} from "../../appStore/actions/profile/action";
import { crossIcon, crossIconDiv } from "../../assets/commonFunction";
import { useTranslation } from "react-i18next";

const classes = {
  drawerBody: {
    minWidth: "31.25rem",
    maxWidth: "31.25rem",
    height: "100%",
  },
  header: {
    backgroundColor: "#F9F8F8",
    color: "#0000",
    padding: "7px 8px",
    mb: "0.4rem",
  },
  iconDiv: crossIconDiv,
  iconn: crossIcon,
};
const FirmProfile = ({ setFirmProfileDrawerOpen }) => {
  const { t } = useTranslation();
  const appContent = t("AppContent", { returnObjects: true });
  const userData = useSelector((state) => state?.profile?.profileData);
  const coverPicRef = useRef(null);
  const profilePicRef = useRef(null);
  const [isEditable, setEditable] = useState(true);
  const [isCountryDrawer, setCountryDrawer] = useState(false);
  const [profileData, setProfileData] = useState({});
  const [coverImage, setCoverImage] = useState({
    src: profileBanner,
    isCoverSelected: false,
    files: "",
  });
  const [profileImage, setProfileImage] = useState({
    src: companyLogo,
    isProfileSelected: false,
    files: "",
  });

  const dispatch = useDispatch();

  // Edits the user has started; live profile updates don't overwrite them.
  const editedRef = useRef(false);

  useEffect(() => {
    dispatch(getCountryList());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Show the account's latest profile, including changes made by another
  // admin, device or tab while this drawer is open.
  useEffect(() => {
    const account = userData?.data?.activeSubscriber;
    if (!editedRef.current) {
      setProfileData({
        city: account?.city || "",
        country: account?.country || "",
        country_code: account?.countryCode || "",
        subscriber_firm_name: account?.subscriberFirmName || "",
        website: account?.website || "",
        profile_brief: account?.profileBrief || "",
        linkedin: account?.linkedin || "",
      });
    }
    setCoverImage((image) =>
      image.isCoverSelected
        ? image
        : { ...image, src: account?.coverImgUrl || profileBanner }
    );
    setProfileImage((image) =>
      image.isProfileSelected
        ? image
        : { ...image, src: account?.profileImgUrl || companyLogo }
    );
  }, [userData]);
  const handleCameraButtonClick = (type) => {
    if (type === "cover") {
      coverPicRef.current.click();
    } else {
      profilePicRef.current.click();
    }
  };

  const handleRemovePic = (type) => {
    if (type === "cover") {
      setCoverImage({
        src: userData?.data?.coverImgUrl
          ? userData?.data?.coverImgUrl
          : profileBanner,
        isCoverSelected: false,
        files: "",
      });
    } else {
      setProfileImage({
        src: userData?.data?.profileImgUrl
          ? userData?.data?.profileImgUrl
          : profileimg,
        isProfileSelected: false,
        files: "",
      });
    }
  };

  const handleProfileImgInputChange = (event) => {
    const file = event.target.files[0];
    setEditable(false);
    if (event.target.name === "cover") {
      setCoverImage({
        ...coverImage,
        src: URL.createObjectURL(file),
        isCoverSelected: true,
        files: file,
      });
    } else {
      setProfileImage({
        ...profileImage,
        src: URL.createObjectURL(file),
        isProfileSelected: true,
        files: file,
      });
    }
  };
  const handleCountryInputChange = (country) => {
    editedRef.current = true;
    setProfileData({
      ...profileData,
      country: country?.name,
      country_code: country?.iso2,
    });
    setCountryDrawer(false);
  };
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    editedRef.current = true;
    // if (name === "url") {
    //   setRequiredInput("url");
    // } else if (name === "website") {
    //   setRequiredInput("website");
    // }
    if (name === "profile_brief") {
      // Limiting the input character
      if (value.length <= 160) {
        setProfileData({
          ...profileData,
          [name]: value,
        });
      }
    }
    if (name !== "profile_brief") {
      setProfileData({
        ...profileData,
        [name]: value,
      });
    }
  };
  const handleUpdateSave = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("data", JSON.stringify(profileData));
    dispatch(
      editSubscriberProfile(
        formData,
        userData?.data?.activeSubscriber?.id,
        true
      )
    ).then(() => setFirmProfileDrawerOpen(false));
    if (coverImage?.isCoverSelected) {
      const formData = new FormData();
      formData.append("files", coverImage?.files);
      formData.append("data", JSON.stringify({ is_cover_image: true }));
      dispatch(updateFirmPic(formData, userData?.data?.activeSubscriber?.id));
    }

    if (profileImage?.isProfileSelected) {
      const formData = new FormData();
      formData.append("files", profileImage?.files);
      formData.append("data", JSON.stringify({ is_cover_image: false }));
      dispatch(updateFirmPic(formData, userData?.data?.activeSubscriber?.id));
    }
  };
  return (
    <Box
      overflow={"scroll"}
      height={"calc(100vh - 16rem)"}
      sx={classes.drawerBody}
    >
      <Stack
        direction="row"
        alignItems="center"
        spacing={2}
        sx={classes.header}
      >
        <Typography sx={classes.iconDiv}>
          <CloseIcon
            sx={classes.iconn}
            onClick={() => setFirmProfileDrawerOpen(false)}
          />
        </Typography>
        <Typography color={"black"}>{appContent?.KEY378}</Typography>
      </Stack>
      <Box
        width={"90%"}
        margin={"auto"}
        overflow={"scroll"}
        height={"calc(100vh - 5rem)"}
        sx={{
          "&::-webkit-scrollbar": {
            width: "1px",
          },
          "&::-webkit-scrollbar-track": {
            background: "#F9F8F8",
          },
          "&::-webkit-scrollbar-thumb": {
            background: "grey",
          },
        }}
      >
        <Drawer sx={{ zIndex: 1202 }} open={isCountryDrawer} anchor={"right"}>
          <CountryDrawer
            handleCountryInputChange={handleCountryInputChange}
            setCountryDrawer={setCountryDrawer}
          />
        </Drawer>
        <Box
          display={"flex"}
          alignItems={"center"}
          justifyContent={"center"}
          bgcolor={"#F3F3F3"}
          padding={"0.25rem"}
        >
          <Box>
            <Typography
              textAlign={"center"}
              variant="h5"
              fontSize={"1rem"}
              fontWeight={600}
            >
              {userData?.data?.activeSubscriber?.subscriberFirmName}
            </Typography>
          </Box>
        </Box>
        <ProfileUpdateForm
          handleInputChange={handleInputChange}
          handleRemovePic={handleRemovePic}
          isEditable={isEditable}
          profileData={profileData}
          handleProfileImgInputChange={handleProfileImgInputChange}
          handleCameraButtonClick={handleCameraButtonClick}
          profileImage={profileImage}
          coverImage={coverImage}
          profilePicRef={profilePicRef}
          coverPicRef={coverPicRef}
          countryDrawer={setCountryDrawer}
          handleSave={handleUpdateSave}
          type={"Firm"}
          setEditable={setEditable}
        />
      </Box>
    </Box>
  );
};

export default FirmProfile;
